import axios from 'axios';

export default {
  login: async (user, password) => {
    const url = `/login/`;
    const response = await axios.post(
      url,
      {user: user, password: password},
      {withCredentials: false}
    );
    return response.data;
  },

  logout: async () => {
    const url = `/login/logout/`;
    const response = await axios.post(url);
    return (response.data || {}).ok || false;
  },

  get: async (token) => {
    const url = `/login/`;
    const response = await axios.get(url, {withCredentials: false});
    return response.data;
  },
};
